import { useState } from "react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Dialog, DialogContent, DialogFooter, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { toast } from "sonner";
import { estApi } from "../lib/api";

/** EST-FRS-2 §4 — "Add to cost library?" for a part the library has no price for. Add / Not now, logged with source. */
export default function LibraryPromptDialog({ line, onClose, onDone }) {
  const [form, setForm] = useState({
    name: line.description || "", item_number: line.item_number || line.frs_item_number || "", manufacturer: line.manufacturer || "",
    unit_cost: line.unit_cost, labor_hours_per_unit: line.labor_hours_per_unit || 0, uom: line.uom || "ea",
  });
  const [busy, setBusy] = useState(false);
  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });
  const quote = line.quote_pricing || null;
  const add = async () => {
    setBusy(true);
    try {
      await estApi.addToLibrary({ line_id: line.id, ...form, unit_cost: Number(form.unit_cost), labor_hours_per_unit: Number(form.labor_hours_per_unit) || 0,
                                  cost_code_id: line.cost_code_id || null, source: quote ? "quote" : "estimate", quote_ref: quote?.quote_ref || "" });
      toast.success("Added to the cost library"); onDone?.();
    } catch (e) { toast.error(e?.response?.data?.detail || "Not added"); } finally { setBusy(false); }
  };
  const notNow = () => { estApi.dismissLibraryPrompt(line.id).catch(() => {}); onClose?.(); };
  return (
    <Dialog open onOpenChange={(v) => !v && notNow()}>
      <DialogContent className="max-w-md" data-testid="library-prompt-dialog">
        <DialogHeader><DialogTitle className="text-sm">Add to cost library?</DialogTitle></DialogHeader>
        <p className="text-xs text-slate-600">
          {line.library_status === "no_cost" ? "The library knows this part but carries no price for it." : "This part / manufacturer / cost code is not in the cost library."}
          {" "}The estimate keeps your price either way.{quote ? ` Tagged quote #${quote.quote_ref || "—"} ${quote.quote_date || ""}.` : ""}
        </p>
        <div className="grid grid-cols-2 gap-2 text-xs">
          <label className="col-span-2">Name<Input value={form.name} onChange={set("name")} className="h-8 text-xs" data-testid="library-prompt-name" /></label>
          <label>Part / model<Input value={form.item_number} onChange={set("item_number")} className="h-8 text-xs" data-testid="library-prompt-part" /></label>
          <label>Manufacturer<Input value={form.manufacturer} onChange={set("manufacturer")} className="h-8 text-xs" data-testid="library-prompt-mfr" /></label>
          <label>Unit cost<Input type="number" step="0.01" value={form.unit_cost} onChange={set("unit_cost")} className="h-8 text-xs" data-testid="library-prompt-cost" /></label>
          <label>Labor h/unit<Input type="number" step="0.01" value={form.labor_hours_per_unit} onChange={set("labor_hours_per_unit")} className="h-8 text-xs" data-testid="library-prompt-labor" /></label>
        </div>
        <DialogFooter>
          <Button variant="outline" size="sm" onClick={notNow} data-testid="library-prompt-not-now">Not now</Button>
          <Button size="sm" onClick={add} disabled={busy || !(Number(form.unit_cost) > 0)} data-testid="library-prompt-add">Add</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
